module.exports = __webpack_public_path__ + "static/media/xk.c21afbc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/xk.png
// module id = 2023
// module chunks = 0